import PositionCard from './PositionCard';

export default PositionCard;
